import {
  BILLING_TRANSACTION_FETCH_REQUEST,
  BILLING_TRANSACTION_FETCH_REQUEST_SUCCESS,
  BILLING_TRANSACTION_FETCH_REQUEST_FAILURE,
  BILLING_TRANSACTION_CLEAN_REQUEST,
  BILLING_TRANSACTION_FILTER_FIELD_SUCCESS,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  filterFields: [],
  loading: false,
  errors: {},
  pagination: {},
};

const billingTransactionReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case BILLING_TRANSACTION_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case BILLING_TRANSACTION_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: [...state.payload, ...action.data.data],
        errors: {},
        pagination: {
          current: action.data.currentPage || 0,
          pageSize: action.data.pageSize || 0,
          total: action.data.totalRecord || 0,
          totalPage: action.data.totalPage || 0,
          showSizeChanger: true,
        },
      });

    case BILLING_TRANSACTION_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case BILLING_TRANSACTION_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {},
      });

    case BILLING_TRANSACTION_FILTER_FIELD_SUCCESS:
      return Object.assign({}, state, {
        filterFields: action.data,
      });

    default:
      return state;
  }
};

export default billingTransactionReducer;
